import usd0Icon from "../../../media/icons/usd0.png";

export function USD0Icon() {
    return (
        <img src={usd0Icon} width={38} height={38} alt='USD0++'/>
    )
}
